import axiosClient from "./axiosClient";
import { TableauTokenPayload } from "../types/analytics";

export const analyticsApi = {
  getToken: (tableauTokenPayload: TableauTokenPayload) =>
    axiosClient.post("/tableau-token", tableauTokenPayload).then(r => r.data),
};
